import { gql } from '@apollo/client';

export const CUSTOM_VALUES_DISCOVERY = gql`
  query CustomValuesDiscovery($input: CustomValuesDiscoveryInput!) {
    customValuesDiscovery(input: $input) {
      customValuesKeys
      totalRecordsAnalyzed
      executionTimeMs
      analysisStartTime
      analysisEndTime
      communityId
    }
  }
`;
